import React from 'react';
import { Button, Spin, Space, Popconfirm, Table } from 'antd';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { activePeriod, disabledDate } from '../../utils/date';
import formatAmount from 'indian-currency-formatter';
import * as Config from '../../appConfig';
import ProfileCard from '../../components/Employee/ProfileCard';

const ConveyancesRevisions = ({ conveyance }) => {
  const {
    user: { ability },
  } = useSelector((state) => state.login);
  const [freezePrevMonth, currentMonth, prevMonth] = activePeriod();

  const columns = [
    {
      title: 'Sl.No',
      dataIndex: 'id',
      key: 'id',
      dataType: 'string',
      className: 'width-100',
    },
    {
      title: 'EMP ID',
      dataIndex: ['employee', 'emp_id'],
      key: 'emp_id',
      dataType: 'string',
      render: (value, record) => {
        return <ProfileCard employee={record.employee} />;
      },
    },
    {
      title: 'Name',
      dataIndex: ['employee', 'first_name'],
      key: 'first_name',
      serverKey: 'NAME',
      ellipsis: true,
      dataType: 'string',
      render: (value, record) => {
        return (
          record && `${record.employee.first_name} ${record.employee.last_name}`
        );
      },
    },
    {
      title: 'Type',
      dataIndex: ['conveyance_type', 'name'],
      key: 'conveyance_type',
      ellipsis: true,
      dataType: 'string',
    },
    {
      title: 'Effective From',
      dataIndex: 'effective_from',
      key: 'effective_from',
      ellipsis: true,
      dataType: 'date',
      format: 'month',
      render: (value, record) => {
        return moment(value).format(Config.DATE_MONTH_FORMAT)
      }
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      ellipsis: true,
      dataType: 'string',
      format: 'currency',
      className: 'cell-currency',
      render: (value, record) => {
        return value && formatAmount(value)
      }
    },
    {
      title: 'Note',
      dataIndex: 'note',
      key: 'note',
      ellipsis: true,
      dataType: 'string',
    },
    {
      title: 'Created By',
      dataIndex: ['createdBy', 'name'],
      key: 'created_by',
      ellipsis: false,
      dataType: 'string',
    },
    {
      title: 'Created Date',
      dataIndex: 'created_at',
      key: 'created_at',
      ellipsis: false,
      dataType: 'date',
      format: 'date',
      render: (value, record) => {
        return moment(value).format(Config.DATE_FORMAT)
      }
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      ellipsis: false,
      disableSearch: true,
      className: 'width-150',
    },
  ];

  return (
    <Table
      size="small"
      bordered={true}
      columns={columns}
      dataSource={
        conveyance.revisions
          ? conveyance.revisions.filter((i) => i.id !== conveyance.id)
          : []
      }
      pagination={false}
      className="subRowTable"
    />
  );
};

export default ConveyancesRevisions;
